import * as stylex from "@stylexjs/stylex";
import { TriangleAlert } from "lucide-react";
import { copy } from "@/copy";
import { type StorageMeter as Meter, type PhotoUsage, storageMeter } from "@/domain/storage";
import "@/theme/tokens.stylex";
import { colors, motion, radii, space } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Eyebrow } from "@/ui/Eyebrow";
import { Icon } from "@/ui/Icon";
type StorageMeterProps = {
  usage: PhotoUsage;
};
const text = copy.settings.account.storage;
const _temp = {
  kzqmXN: "x5lhr3w",
  "$$css": true
};
const styles = {
  fill: {
    kZKoxP: "x5yr21d",
    kaIpWk: "xqhrb7l",
    kWkggS: "x1i4uan3",
    k1ekBW: "xxrbq2n",
    kIyJzY: "x1fmhw06",
    kAMwcw: "xwji4o3",
    $$css: true
  },
  fillDanger: {
    kWkggS: "xi9wlog",
    $$css: true
  },
  fillWidth: (fraction: number) => [_temp, {
    "--x-width": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(`${(fraction * 100).toFixed(1)}%`)
  }]
};
export function StorageMeter({
  usage
}: StorageMeterProps) {
  const meter = storageMeter(usage.used, usage.limit);
  const used = text.used(meter.used, meter.limit);
  const warn = meter.level !== "ok";
  return <div className="x78zum5 xdt5ytf x152posx">
      <Eyebrow>{text.title}</Eyebrow>
      <div className="x78zum5 xdt5ytf x1hu4l6k x14hcewi x1fv5t7x x5r8ks9">
        <div className="x78zum5 x1a02dak x1pha0wt x1qughib xr5592y">
          <span className="xneq65o x1v94iar xrg9stw xss6m8b">{leftText(meter)}</span>
          <span className="xr0iwhn xif65rj xkv8mnm xtvhhri xss6m8b">{used}</span>
        </div>
        {/* biome-ignore lint/a11y/useSemanticElements: a native meter can't take the pill track, hairline ring and animated fill */}
        <div role="meter" aria-label={text.meter} aria-valuemin={0} aria-valuemax={meter.limit} aria-valuenow={meter.used} aria-valuetext={used} className="x1kpxq89 xb3r6kr xqhrb7l xh540kj x98nf4m">
          <div {...stylex.props(styles.fill, warn && styles.fillDanger, styles.fillWidth(meter.fraction))} />
        </div>
        <span className="x78zum5 x1cy8zhl x152posx x1jvydc1 x15i68ds x37zpob x1fzhlzt">
          {warn && <span className="x78zum5 x2lah0s x4p5aij x3258oq">
              <Icon icon={TriangleAlert} size={18} />
            </span>}
          {noteText(meter)}
        </span>
      </div>
    </div>;
}
function leftText(meter: Meter): string {
  return meter.level === "full" ? text.noneLeft : text.left(meter.left, meter.unit);
}
function noteText(meter: Meter): string {
  if (meter.level === "full") return text.full;
  return meter.level === "almost" ? text.almost : text.ok;
}